export const ROOT = '/clients';
export const MODULE = 'CLIENTS';
